import script from "./IntakeStyles.vue?vue&type=script&setup=true&lang=js"
export * from "./IntakeStyles.vue?vue&type=script&setup=true&lang=js"

import "./IntakeStyles.vue?vue&type=style&index=0&id=342860b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342860b6"]])

export default __exports__